import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { MatDialogModule} from '@angular/material/dialog';
import { MatTooltipModule } from '@angular/material/tooltip';
import {MatExpansionModule} from '@angular/material/expansion';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {MatToolbarModule} from '@angular/material/toolbar';
import { MAT_DATE_FORMATS, MAT_DATE_LOCALE } from '@angular/material/core';
import { MatCardModule } from '@angular/material/card';
import { MatTabsModule } from '@angular/material/tabs';
import { MainEnovskyComponent } from './back-office/enovsky/main-enovsky/main-enovsky.component';
import { LoginComponent } from './back-office/components/login/login.component';
import { RegistrationComponent } from './back-office/components/registration/registration.component';
import { DialogComponent } from './back-office/components/dialog/dialog.component';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FlexLayoutModule } from '@angular/flex-layout';
import {ApiServiceModule} from './back-office/modules/api-service.module';
import { HelperModule } from './back-office/modules/helper.module';
import { HttpClient, HttpClientModule } from '@angular/common/http';
import { MatSnackBar } from '@angular/material/snack-bar';
import {MatFormFieldModule} from '@angular/material/form-field';
import { MatTableModule } from '@angular/material/table';
import { MatSliderModule } from '@angular/material/slider';
import {MatInputModule} from '@angular/material/input';
import {FormsModule, ReactiveFormsModule} from '@angular/forms';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { MainVirtualCampusComponent } from './back-office/virtualcampus/main-virtualcampus/main-virtualcampus.component';
import { MainVirtualclassComponent } from './back-office/virtualclass/main-virtualclass/main-virtualclass.component';
import { RouterModule, Routes } from '@angular/router';
import { MatIconModule } from '@angular/material/icon';
import { MatSidenavModule } from '@angular/material/sidenav';
import { MatListModule } from '@angular/material/list';
import { MainComponent } from './back-office/main/main.component';
import {MatButtonModule} from '@angular/material/button';
import { MatDatepickerModule } from "@angular/material/datepicker";
import { MonacoEditorModule } from 'ngx-monaco-editor-v2';
import { MatNativeDateModule, MatRippleModule } from "@angular/material/core";
import {MatProgressBarModule} from '@angular/material/progress-bar';
import { SideEnovskyComponent } from './back-office/enovsky/side-enovsky/side-enovsky.component';
import { SideVirtualCampusComponent } from './back-office/virtualcampus/side-virtualcampus/side-virtualcampus.component';
import { VcaUploadContentComponent } from './back-office/virtualcampus/vca-upload-content/vca-upload-content.component';
import { VcaFilterComponent } from './back-office/virtualcampus/vca-filter/vca-filter.component';
import {MatSelectModule} from '@angular/material/select';
import { TableComponent } from './back-office/components/table/table.component';
import { VcaDetailContentComponent } from './back-office/virtualcampus/vca-ressource-manager/vca-content/vca-detail-content/vca-detail-content.component';
import { ProfileEnovskyComponent } from './back-office/enovsky/profile-enovsky/profile-enovsky.component';
import { PdfViewerComponent } from './back-office/components/pdf-viewer/pdf-viewer.component';
import { VcaContentComponent } from './back-office/virtualcampus/vca-ressource-manager/vca-content/vca-content.component';
import { VcaCreateProjectComponent } from './back-office/virtualcampus/vca-create-project/vca-create-project.component';
import { VcaContentProjectComponent } from './back-office/virtualcampus/vca-content-project/vca-content-project.component';
import { ProjectSettingComponent } from './back-office/components/project-content/project-setting/project-setting.component';
import { ProjectEditingComponent } from './back-office/components/edit-project/project-editing/project-editing.component';
import { ProjectSplitingComponent } from './back-office/components/edit-project/project-spliting/project-spliting.component';
import { SideVirtualclassComponent } from './back-office/virtualclass/side-virtualclass/side-virtualclass.component';
import { VcContentComponent } from './back-office/virtualclass/vcl-ressource-manager/vcl-content/vcl-content.component';
import { VcContentProjectComponent } from './back-office/virtualclass/vcl-content-project/vcl-content-project.component';
import { VcCreateProjectComponent } from './back-office/virtualclass/vcl-create-project/vcl-create-project.component';
import { VcUploadContentComponent } from './back-office/virtualclass/vcl-upload-content/vcl-upload-content.component';
import { VcFilterComponent } from './back-office/virtualclass/vcl-filter/vcl-filter.component';
import { ProjectContentComponent } from './back-office/components/project-content/project-content.component';
import { ProjectCreationComponent } from './back-office/components/project-creation/project-creation.component';
import { UploadContentComponent } from './back-office/components/upload-content/upload-content.component';
import { RawSettingComponent } from './back-office/components/project-creation/raw-setting/raw-setting.component';
import { ProjectClassifyComponent } from './back-office/components/edit-project/project-editing/project-classify/project-classify.component';
import { UserAdminComponent } from './back-office/enovsky/user-admin/user-admin.component';
import { VcDetailContentComponent } from './back-office/virtualclass/vcl-ressource-manager/vcl-content/vcl-detail-content/vcl-detail-content.component';
import { ClassifySettingComponent } from './back-office/components/edit-project/project-editing/classify-setting/classify-setting.component';
import { ServerAdminComponent } from './back-office/enovsky/server-admin/server-admin.component';
import { DocumentationComponent } from './back-office/enovsky/documentation/documentation.component';
import { VcaStudentDashboardComponent } from './back-office/virtualcampus/vca-student-dashboard/vca-student-dashboard.component';
import { VcStudentDashboardComponent } from './back-office/virtualclass/vcl-student-dashboard/vcl-student-dashboard.component';
import { VcStudentManagerComponent } from './back-office/virtualclass/vcl-student-manager/vcl-student-manager.component';
import { VcaStudentManagerComponent } from './back-office/virtualcampus/vca-student-manager/vca-student-manager.component';
import { ChatMainComponent } from './chat/chat-main/chat-main.component';
import { EnovskyBannerComponent } from './enovsky/enovsky-banner/enovsky-banner.component';
import { VcaAdvertismentComponent } from './back-office/virtualcampus/vca-advertisment/vca-advertisment.component';
import { VcaPromotionComponent } from './back-office/virtualcampus/vca-promotion/vca-promotion.component';
import { VclPromotionComponent } from './back-office/virtualclass/vcl-promotion/vcl-promotion.component';
import { VclAdvertismentComponent } from './back-office/virtualclass/vcl-advertisment/vcl-advertisment.component';
import { AdvertismentComponent } from './back-office/components/advertisment/advertisment.component';
import { PromotionComponent } from './back-office/components/promotion/promotion.component';
import { DetailAdvertismentComponent } from './back-office/components/advertisment/detail-advertisment/detail-advertisment.component';
import { SettingPromotionComponent } from './back-office/components/promotion/setting-promotion/setting-promotion.component';
import { SettingAdvertismentComponent } from './back-office/components/advertisment/setting-advertisment/setting-advertisment.component';
import { EnovskyComponent } from './enovsky/enovsky.component';
import { DataPolicyComponent } from './enovsky/data-policy/data-policy.component';
import { DataDeletionComponent } from './enovsky/data-deletion/data-deletion.component';
import { DashboardComponent } from './back-office/components/dashboard/dashboard.component';
import { StudentManagerComponent } from './back-office/components/student-manager/student-manager.component';
import { MailSenderComponent } from './back-office/components/student-manager/mail-sender/mail-sender.component';
import { MarkdownEditorComponent } from './back-office/components/markdown-editor/markdown-editor.component';
import { EpanelMainComponent } from './epanel/epanel-main/epanel-main.component';
import { FloatWindowComponent } from './back-office/components/float-window/float-window.component';
import { StudentDetailComponent } from './back-office/components/student-manager/student-detail/student-detail.component';
import { EnovskyDrawComponent } from './enovsky-draw/enovsky-draw.component';
import { EnovskyDrawModalComponent } from './enovsky-draw/enovsky-draw-modal/enovsky-draw-modal.component';
import { VcaRessourceManagerComponent } from './back-office/virtualcampus/vca-ressource-manager/vca-ressource-manager.component';
import { VcaDepartmentModuleComponent } from './back-office/virtualcampus/vca-ressource-manager/vca-department-module/vca-department-module.component';
import { VcaDetailDepModComponent } from './back-office/virtualcampus/vca-ressource-manager/vca-department-module/vca-detail-dep-mod/vca-detail-dep-mod.component';
import { VclRessourceManagerComponent } from './back-office/virtualclass/vcl-ressource-manager/vcl-ressource-manager.component';
import { VclInstitutionModuleComponent } from './back-office/virtualclass/vcl-ressource-manager/vcl-institution-module/vcl-institution-module.component';
import { VclDetailInsModComponent } from './back-office/virtualclass/vcl-ressource-manager/vcl-institution-module/vcl-detail-ins-mod/vcl-detail-ins-mod.component';
import { SettingUserComponent } from './back-office/enovsky/user-admin/setting-user/setting-user.component';
import { ManagementComponent } from './back-office/enovsky/management/management.component';
import { ActivityDetailsComponent } from './back-office/enovsky/management/activity-details/activity-details.component';

@NgModule({
  declarations: [
    AppComponent,
    MainEnovskyComponent,
    LoginComponent,
    RegistrationComponent,
    DialogComponent,
    MainVirtualCampusComponent,
    MainVirtualclassComponent,
    MainComponent,
    SideEnovskyComponent,
    SideVirtualCampusComponent,
    VcaUploadContentComponent,
    VcaFilterComponent,
    TableComponent,
    VcaDetailContentComponent,
    ProfileEnovskyComponent,
    PdfViewerComponent,
    VcaContentComponent,
    VcaCreateProjectComponent,
    VcaContentProjectComponent,
    ProjectSettingComponent,
    ProjectEditingComponent,
    ProjectSplitingComponent,
    SideVirtualclassComponent,
    VcContentComponent,
    VcContentProjectComponent,
    VcCreateProjectComponent,
    VcUploadContentComponent,
    VcFilterComponent,
    ProjectContentComponent,
    ProjectCreationComponent,
    UploadContentComponent,
    RawSettingComponent,
    ProjectClassifyComponent,
    UserAdminComponent,
    VcDetailContentComponent,
    ClassifySettingComponent,
    ServerAdminComponent,
    DocumentationComponent,
    VcaStudentDashboardComponent,
    VcStudentDashboardComponent,
    VcStudentManagerComponent,
    VcaStudentManagerComponent,
    ChatMainComponent,
    EnovskyBannerComponent,
    VcaAdvertismentComponent,
    VcaPromotionComponent,
    VclPromotionComponent,
    VclAdvertismentComponent,
    AdvertismentComponent,
    PromotionComponent,
    DetailAdvertismentComponent,
    SettingPromotionComponent,
    SettingAdvertismentComponent,
    DataPolicyComponent,
    EnovskyComponent,
    DataDeletionComponent,
    DashboardComponent,
    StudentManagerComponent,
    MailSenderComponent,
    MarkdownEditorComponent,
    EpanelMainComponent,
    FloatWindowComponent,
    StudentDetailComponent,
    EnovskyDrawComponent,
    EnovskyDrawModalComponent,
    VcaRessourceManagerComponent,
    VcaDepartmentModuleComponent,
    VcaDetailDepModComponent,
    VclRessourceManagerComponent,
    VclInstitutionModuleComponent,
    VclDetailInsModComponent,
    SettingUserComponent,
    ManagementComponent,
    ActivityDetailsComponent,
  ],
  imports: [
    MatButtonModule,
    BrowserModule,
    MatToolbarModule,
    AppRoutingModule,
    BrowserAnimationsModule,
    MatDialogModule,
    MatDatepickerModule,
    MatNativeDateModule,
    MatExpansionModule,
    MatCardModule,
    MatTabsModule,
    BrowserModule,
    HttpClientModule,
    FlexLayoutModule,
    MatFormFieldModule,
    MatSliderModule,
    MatTooltipModule,
    MatTableModule,
    FormsModule,
    ReactiveFormsModule,
    MatInputModule,
    MatIconModule,
    MatSelectModule,
    MatSidenavModule,
    MatListModule,
    MatProgressBarModule,
    DragDropModule,
    MonacoEditorModule.forRoot(),
    RouterModule.forRoot(getDynamicRoutes()),
  ],
  providers: [{provide: MAT_DATE_LOCALE, useValue: 'fr-FR'}, ApiServiceModule, HelperModule, HttpClient, MatSnackBar],
  bootstrap: [AppComponent]
})
export class AppModule { }

export function getDynamicRoutes(): Routes {
  const urlDomain = window.location.hostname; 
  
  if(urlDomain === 'back-office.enovsky.com') return [
    { path: '', component: MainEnovskyComponent },
    { path: 'virtualcampus', component: MainVirtualCampusComponent },
    { path: 'virtualclass', component: MainVirtualclassComponent }
  ]
  else if(urlDomain === 'enovsky.com' || urlDomain === 'chat.enovsky.com') return [
    { path: '', component: EnovskyBannerComponent },
    { path: 'policy', component: DataPolicyComponent },
    { path: 'data-deletion', component: DataDeletionComponent},
  ]
  else if(urlDomain === 'epanel.enovsky.com') return [
    { path: '', component: EpanelMainComponent },
    { path: 'connect', component: EpanelMainComponent },
    { path: 'build-pdf', component: EpanelMainComponent},
    { path: 'edit-pdf', component: EpanelMainComponent},
    { path: 'pdf-to-docx', component: EpanelMainComponent },
    { path: 'docx-to-pdf', component: EpanelMainComponent},
  ]
  else return [];
}
